<template>

  <div class="container">

    <div class="row">

      <div class="col-12 offset-0 col-md-12 text-center mb-5">

        <h4 class="mb-4 menu-dark font-weight-light">Add Card</h4>

          <b-alert v-if="error" show variant="danger">
            <h4 class="alert-heading">Error</h4>
            <p class="alert-danger">
              {{error}}
            </p>
          </b-alert>

        <div class="col-12 offset-0 col-md-6 offset-md-3 bg-white py-3">
          <div id="card-element"></div>
        </div>

        <b-form-group>
        <b-button id="submit-button" @click="addCard" class="disabled" variant="success mx-auto mt-5 px-4">
          Add Card
        </b-button>
          </b-form-group>

      </div>

    </div>

  </div>

</template>

<script src="https://js.stripe.com/v3/"></script>

<script>
let stripe = Stripe(process.env.VUE_APP_STRIPE_KEY);
let elements = stripe.elements();
var cardElement = elements.create('card')

cardElement.on('change', function(event) {
  if (event.complete) {
    // enable payment button
    var element = document.getElementById("submit-button");
    element.classList.remove("disabled");
  } else if (event.error) {
    // show validation to customer
  }
});

import axios from 'axios';

export default {
  name: 'AddCard',
  data() {
    return  {
      error: null,
      accounts: [],
    }
  },
  methods: {
    loadData () {

      let token = null;

      try {
        token = this.$store.getters.getToken.access
      } catch (err) {
        this.$router.replace({name: 'auth-error'})
      }

      //localStorage.getItem('accessToken')
      let headers = {
        'Authorization': 'JWT ' + token
      }

      axios.get('/chipin/account/cards/', {'headers': headers})
          .then(res => {
            console.log(res.data)
            this.accounts = res.data.accounts
          })
          .catch(error => {
            this.name = 'Sorry something went wrong!';
            console.log(error)
          });

    },
    addCard () {

      var cardElement = elements.getElement('card');

      let token = null;

      try {
        token = this.$store.getters.getToken.access
      } catch (err) {
        this.$route.replace({name: 'auth-error'})
      }

      this.error = null;

      let self = this;

      stripe.createToken(cardElement)
      .then(function(result) {

        // Handle result.error or result.token
        if (result.token) {

          // send token to server

          //localStorage.getItem('accessToken')
          let headers = {
            'Authorization': 'JWT ' + token
          }

          axios.post('/chipin/account/cards/', {
            "stripe_token": result.token.id
          }, {'headers': headers})
              .then(res => {

                self.$router.replace({name: 'cards'});

              })
              .catch(error => {
                self.name = 'Sorry something went wrong!';
                self.error = 'Sorry something went wrong!';
              });

        } else if (result.error) {
          // parse error and show to user
          
          var msg = result.error.message;
          self.error = msg

        }
      });

    }
  },
  beforeMount(){
      this.loadData()
   },
  mounted: function () {
    cardElement.mount('#card-element')
  },
}
</script>
